import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<string>?} State */
const initialState = [];

const setLanguages = (_, { payload: languages }) => languages;

export default createReducer(initialState, {
  [types.SET_LANGUAGES]: setLanguages,
});
